import { FC } from "react";

import { ReactNode } from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "~/components/ui/tooltip";

const ConditionalTooltip: FC<{
  children: ReactNode;
  message?: string | ReactNode;
}> = ({ children, message }) => {
  return message ? (
    <Tooltip>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent>{message}</TooltipContent>
    </Tooltip>
  ) : (
    children
  );
};

export default ConditionalTooltip;
